import {Nullish} from 'shared/web';

type Item = {isActive?: boolean | Nullish; id?: string | Nullish; description?: string | Nullish};

export const getActiveOptions = <T extends Item | Nullish>(items: T[] | Nullish) =>
  items
    ?.filter((item) => item?.isActive)
    .map((item) => ({label: item?.description ?? '', value: item?.id ?? ''})) ?? [];
